import {
  groupNodeCreateStartAtom,
  isDraggingNodeAtom,
  isViewOnlyModeAtom,
  sidebarOpenNodeIdAtom,
  singleSelectedNodeIdAtom,
  singleSelectedNodeTypeAtom,
} from "@zapier/canvas-state";
import { useAtomValue } from "jotai";

import { NodeSidebar } from "../NodeSidebar";
import { PathSidebar } from "../PathSidebar";
import { ViewOnlyNodeSidebar } from "../ViewOnlyNodeSidebar";

export function Sidebar() {
  const singleSelectedNodeId = useAtomValue(singleSelectedNodeIdAtom);
  const singleSelectedNodeType = useAtomValue(singleSelectedNodeTypeAtom);
  const groupNodeCreateStart = useAtomValue(groupNodeCreateStartAtom);
  const sidebarOpenNodeId = useAtomValue(sidebarOpenNodeIdAtom);
  const isDraggingNode = useAtomValue(isDraggingNodeAtom);
  const isViewOnlyMode = useAtomValue(isViewOnlyModeAtom);

  if (isDraggingNode) {
    return null;
  }

  // The following sidebars open when you click the node since there's no floating toolbar for them
  // Needs to go first so that clicking "View note" in read-only mode won't open the editable sidebar
  if (singleSelectedNodeId) {
    const nodeType = singleSelectedNodeType;
    if (isViewOnlyMode) {
      if (["zap", "default"].includes(nodeType)) {
        return <ViewOnlyNodeSidebar nodeId={singleSelectedNodeId} />;
      }
    }

    if (["path"].includes(nodeType)) {
      return <PathSidebar id={singleSelectedNodeId} />;
    }
  }

  if (
    !groupNodeCreateStart &&
    singleSelectedNodeId &&
    singleSelectedNodeId === sidebarOpenNodeId
  ) {
    return <NodeSidebar id={singleSelectedNodeId} />;
  }

  return null;
}
